var urlHistory;

function getOffsetFromTopOfPage(el) {
    let rect = el.getBoundingClientRect(),
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
}

function performOffset(e){
    e.preventDefault();
    let header = document?.body?.querySelector('header');
    let anchor = document?.body?.querySelector(e.target.closest('a').hash);
    let anchorPosition = getOffsetFromTopOfPage(anchor);
    let offsetAmount = header.offsetHeight + 15;
    anchor.scrollIntoView({behavior: "smooth", block: 'start', inline: 'nearest'});
    window.scrollTo({top: anchorPosition - offsetAmount, behavior: 'smooth'});
    if (urlHistory) {
        urlHistory.push(e.target.closest('a').hash);
    }
    return false;
}

export function handleAnchorOffsetUrlHash(){
    //timeout of zero to wait for dom load
    setTimeout(function(){
        let hash = window.location.hash;
        if(hash == "#maincontent") return;
        if(hash.length == 0 || !(/^[A-Za-z\#]+[\w\-\:\.]*$/).test(hash)) return;
        let anchor = document?.body.querySelector(hash);

        if(!anchor) return;
        let header = document?.body?.querySelector('header');
        let anchorPosition = getOffsetFromTopOfPage(anchor);
        let offsetAmount = header.offsetHeight + 15;
        anchor.scrollIntoView({behavior: "smooth", block: 'start', inline: 'nearest'});
        window.scrollTo({top: anchorPosition - offsetAmount, behavior: 'smooth'});
    },0);
}

export function handleAnchorOffset(container, history?) {
    const anchorLinks = container?.querySelectorAll('a[href^="#"]');
    urlHistory = history;
    anchorLinks.forEach((link) => {
        link.addEventListener('click', performOffset, false);
    });
}